export default "__VITE_ASSET__d97df6f6__"